import { DomSanitizer } from '@angular/platform-browser';
import { PointOfInterest } from './../itineray.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-customer-itinerary-marker',
  templateUrl: './customer-itinerary-marker.component.html',
  styleUrls: ['./customer-itinerary-marker.component.css']
})
export class CustomerItineraryMarkerComponent implements OnInit {

  @Input()
  poi: PointOfInterest;

  @Input()
  index?: number;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }


  sanitizeImageUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getPoiGoogleMapsUrl(poi: PointOfInterest) {
    const query: string = poi.place.position.latitude.toString() + ", " + poi.place.position.longitude.toString();
    const queryPlaceId: string = poi.place.id;

    let url: string = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(query);

    if (queryPlaceId != null) {
      url += '&query_place_id=' + encodeURIComponent(queryPlaceId);
    }
    return url;
  }

}
